import { decimalPrice, formatPrice, getCurrencySymbol } from './priceFormatting';
export const getPriceDisplayProps = _ref => {
  let {
    currencySettings,
    monthlyPrice,
    maximalMonthlyPrice,
    monthsPerCycle,
    quantity = 1
  } = _ref;
  const isYearlyResolution = monthsPerCycle > 1 && decimalPrice(monthlyPrice, currencySettings) < 5;
  const totalPrice = monthlyPrice * monthsPerCycle * quantity;
  const totalPriceStr = formatPrice(totalPrice, currencySettings);
  const pricePerYear = monthlyPrice * 12 * quantity;
  const pricePerYearStr = formatPrice(pricePerYear, currencySettings);
  const pricePerMonth = monthlyPrice * quantity;
  const pricePerMonthStr = formatPrice(pricePerMonth, currencySettings);
  const maximalPricePerMonth = (maximalMonthlyPrice ?? pricePerMonth) * quantity;
  const maximalPricePerMonthStr = formatPrice(maximalPricePerMonth, currencySettings);
  const maximalPricePerYear = maximalPricePerMonth * 12;
  const maximaPricePerYearStr = formatPrice(maximalPricePerYear, currencySettings);
  const maximalTotalPrice = maximalPricePerMonth * monthsPerCycle;
  const maximalTotalPriceStr = formatPrice(maximalTotalPrice, currencySettings);
  const maximalTotalPriceDecimal = decimalPrice(maximalTotalPrice, currencySettings);
  const savingsPerMonth = Math.max(maximalPricePerMonth - pricePerMonth, 0);
  const savingsPerMonthStr = formatPrice(savingsPerMonth, currencySettings);
  const savingsPerMonthDecimal = decimalPrice(savingsPerMonth, currencySettings);
  const savingsPerYear = Math.max(maximalPricePerYear - pricePerYear, 0);
  const savingsPerYearStr = formatPrice(savingsPerYear, currencySettings);
  const savingsPerYearDecimal = decimalPrice(savingsPerYear, currencySettings);
  const totalSavings = Math.max(maximalTotalPrice - totalPrice >= 20 ? maximalTotalPrice - totalPrice : 0, 0);
  const totalSavingsStr = formatPrice(totalSavings, currencySettings);
  const totalSavingsDecimal = decimalPrice(totalSavings, currencySettings);
  const isFree = pricePerYear === 0 && savingsPerYearDecimal > 5;
  return {
    isYearlyResolution,
    isFree,
    totalPrice,
    totalPriceStr,
    totalSavings,
    totalSavingsStr,
    totalSavingsDecimal,
    maximalTotalPrice,
    maximalTotalPriceStr,
    maximalTotalPriceDecimal,
    pricePerYear,
    pricePerYearStr,
    savingsPerYear,
    savingsPerYearStr,
    savingsPerYearDecimal,
    maximalPricePerYear,
    maximaPricePerYearStr,
    pricePerMonth,
    pricePerMonthStr,
    savingsPerMonth,
    savingsPerMonthStr,
    maximalPricePerMonth,
    maximalPricePerMonthStr,
    savingsPerMonthDecimal,
    currencySymbol: getCurrencySymbol(currencySettings)
  };
};
//# sourceMappingURL=getPriceDisplayProps.js.map